import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import Modal from "react-modal";
import { loadEnvironmentVariables } from "./environment";

loadEnvironmentVariables().finally(() => {
  const rootNode = document.getElementById("root");
  const App = require("./App").default;
  ReactDOM.render(<App />, rootNode);
  Modal.setAppElement("#root");

  if (module.hot) {
    module.hot.accept("./App", () => {
      const NextApp = require("./App").default;
      ReactDOM.render(<NextApp />, rootNode);
    });
  }
});

if (process.env.REACT_APP_ENABLE_MIMIC === "true") {
  require("mimic");
}

// Add a global variable to see the latest commit in the browser
window.gitblame = process.env.LAST_COMMIT;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
    value: function(callback, type, quality) {
      var canvas = this;
      setTimeout(function() {
        var binStr = atob(canvas.toDataURL(type, quality).split(",")[1]),
          len = binStr.length,
          arr = new Uint8Array(len);

        for (var i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }

        callback(new Blob([arr], { type: type || "image/png" }));
      });
    },
  });
}
